import React from 'react'
import { useHistory } from 'react-router-dom'
import { css, SerializedStyles } from '@emotion/core'
import { AccountContext } from '@/contexts/account'
import { useContext } from 'react'
import { hasStaffRole } from '@/libs/account'

type Props = {
  guestName: string | null | undefined
  reservationUuid: string
  reservationId: string
  isOpenInNewTab?: boolean
  customTextStyle?: SerializedStyles
  customLinkStyle?: SerializedStyles
}

export const LinkedText: React.FC<Props> = ({ guestName, reservationUuid, reservationId, customTextStyle, customLinkStyle }) => {
  const { account } = useContext(AccountContext)
  const history = useHistory()
  const canLink = hasStaffRole(account)
  const linkUrl = `/reservation/${reservationUuid}?reservationId=${reservationId}`

  return canLink && guestName ? (
    <a href={linkUrl} css={[defaultLinkStyle, customLinkStyle]}>
      {guestName}
    </a>
  ) : (
    <p css={[defaultTextStyle, customTextStyle]}>{guestName || '-'}</p>
  )
}

const defaultLinkStyle = css({
  color: '#F2A40B',
  cursor: 'pointer',
  '&:hover': {
    color: '#F2A40B',
  },
})

const defaultTextStyle = css({
  color: '#272727',
})
